import { Icon } from '@blueprintjs/core'
import { Tooltip2 } from '@blueprintjs/popover2'

export default function LabelWithTooltip({ label, tooltip }) {
  return (
    <span style={{ display: 'inline-flex', alignItems: 'center', gap: 5 }}>
      <span>{label}</span>
      <Tooltip2 content={tooltip}>
        <span style={{ display: 'inline-flex', alignItems: 'center', height: '1em' }}>
          <Icon
            icon="info-sign"
            size={12}
            style={{
              cursor: 'help',
              color: '#5C7080',
            }}
          />
        </span>
      </Tooltip2>
    </span>
  )
}
